import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router";
import { useCheckCode, useSendCard, useGetSettings } from "../../../Services/Api";
import useSound from "use-sound";
//звуки
import err from '../sounds/err.mp3';
import used from '../sounds/usedCode.mp3';
import newCode from '../sounds/newCode.mp3';
import saveSucsess from '../sounds/saveSucsess.mp3';
import { Stage1 } from "./Stage1";
import { Stage2 } from "./Stage2";
import { Stage3 } from "./Stage3";
import { MainForm } from "./MainForm";

import { useLocalStorageState } from "./lib"

const Form2 = () => {
  //звуки
  const [playErr] = useSound(err);
  const [playUsed] = useSound(used);
  const [playNewCode] = useSound(newCode);
  const [playSaveSucsess] = useSound(saveSucsess);

  const [stage, setStage, clearStage] = useLocalStorageState('stage', '1');

  const [mainFormState, setMainFormState, clearMainFormState] = useLocalStorageState('mainFormState', 'edit')
  const [aggLevelId, setAggLevelId] = useLocalStorageState("ggLevelId", 1)
  const [aggrCode, setAggrCode, clearAggrCode] = useLocalStorageState('aggrCode', '');
  const [order, setOrder, clearOrder] = useLocalStorageState('order', '');
  const [barCode, setBarCode, clearBarCode] = useLocalStorageState('barCode', '');
  const [boxSize, setBoxSize, clearBoxSize] = useLocalStorageState('boxSize', 0);
  const [productName, setProductName, clearProductName] = useLocalStorageState('productName', '');
  const [kms, setKms, clearKms, saveKmsToLocalStorage] = useLocalStorageState('kms', []);
  const [date, setDate, clearDate, saveProductDateToLocalStorage] = useLocalStorageState('productDate', '');
  const [autocomplete, setAutocomplete] = useLocalStorageState('autocomplete', false);
  const [withoutAgregation, setWithoutAgregation] = useLocalStorageState('withoutAgregation', false);

  const setStage1Rezult = (aggrCode, productName) => {
    setAggrCode(aggrCode);
    setProductName(productName);
    setStage('2');
    if (!withoutAgregation) playSaveSucsess();
  }

  const setStage2Rezult = (kms) => {
    setKms(kms);
    setStage('3');
  }
  const setStage3Rezult = () => {
    setStage('1');
    setAggrCode('');
    setKms([]);
    // setProductDate(localStorage.getItem('productDate') || '');
    if (!autocomplete) playSaveSucsess();
  }
  const fullReset = () => {
    clearStage();
    clearAggrCode();
    clearKms();
    // clearDate();
    // clearBarCode();
    // clearBoxSize();
    // clearProductName();
    clearMainFormState();
    // clearOrder();
  }

  return (
    <div className="form2">
      <MainForm
        stage={stage}
        date={date}
        setDate={setDate}
        barCode={barCode}
        setBarCode={setBarCode}
        order={order}
        setOrder={setOrder}
        boxSize={boxSize}
        setBoxSize={setBoxSize}
        mainFormState={mainFormState}
        setMainFormState={setMainFormState}
        fullReset={fullReset}
        autocomplete={autocomplete}
        setAutocomplete={setAutocomplete}
        withoutAgregation={withoutAgregation}
        setWithoutAgregation={setWithoutAgregation}
        aggLevelId={aggLevelId} 
        setAggLevelId={setAggLevelId}
      />
      {stage === '1' && mainFormState === "saved" && <Stage1
        setRezult={setStage1Rezult}
        boxSize={boxSize}
        withoutAgregation={withoutAgregation}
        barCode={barCode}
        aggLevelId={aggLevelId} 
      />}
      {stage === '2' && mainFormState === "saved" && <Stage2
        setRezult={setStage2Rezult}
        productName={productName}
        aggrCode={aggrCode}
        initialKms={kms}
        barCode={barCode}
        boxSize={boxSize}
        aggLevelId={aggLevelId} 
        stateSave={saveKmsToLocalStorage} 
        />}
      {stage === '3' && mainFormState === "saved" && <Stage3
        setRezult={setStage3Rezult}
        aggrCode={aggrCode}
        kms={kms}
        productDate={date}
        barCode={barCode}
        order={order}
        autocomplete={autocomplete}
        withoutAgregation={withoutAgregation}
        saveProductDate={saveProductDateToLocalStorage} 
        boxSize={boxSize}
        aggLevelId={aggLevelId} 
        />}

    </div>
  )
}

export default Form2;